import { getAction } from '@/api/manage'

const API_BASE = '/api/plugin/money-detail/moneyDetail'

export function getList(params) {
  return getAction(`${API_BASE}/getList`, params)
}

export default { getList }